/**
 * Errores de la capa de dominio.
 *
 * Todos llevan un mensaje en espanol listo para mostrar en pantalla. El dominio
 * nunca lanza cadenas sueltas: un error tipado permite distinguir un dato mal
 * capturado de una falla del programa.
 */

export class ErrorDominio extends Error {
  readonly codigo: string;

  constructor(codigo: string, mensaje: string) {
    super(mensaje);
    this.name = 'ErrorDominio';
    this.codigo = codigo;
  }
}

/**
 * Se lanza al intentar convertir entre dimensiones incompatibles, por ejemplo
 * gramos a mililitros, sin un factor de equivalencia definido.
 *
 * Es preferible fallar de forma visible que devolver un numero aproximado:
 * un error de dimension desvia el costo por un factor de 1000 (Req. 5.5).
 */
export class ErrorConversionUnidades extends ErrorDominio {
  constructor(mensaje: string) {
    super('conversion_unidades', mensaje);
    this.name = 'ErrorConversionUnidades';
  }
}

/** Se lanza cuando un dato capturado no cumple las reglas de validacion. */
export class ErrorValidacion extends ErrorDominio {
  readonly campo: string | null;

  constructor(mensaje: string, campo: string | null = null) {
    super('validacion', mensaje);
    this.name = 'ErrorValidacion';
    this.campo = campo;
  }
}

/** Se lanza cuando un archivo de respaldo no puede aceptarse. */
export class ErrorRespaldo extends ErrorDominio {
  constructor(mensaje: string) {
    super('respaldo', mensaje);
    this.name = 'ErrorRespaldo';
  }
}
